import type { TableProps } from 'antd/es/table';
import type { QCTaskRow, QCTasksTableConfigOptions } from './types';
import { buildColumns } from './columns';
import { components, rowClassName, onRow } from './tableComponents';

export function createQCTasksTableConfig(opts?: QCTasksTableConfigOptions) {
  const columns = buildColumns(opts);
  return {
    columns,
    components,
    rowClassName,
    onRow,
  } as {
    columns: ReturnType<typeof buildColumns>;
    components: TableProps<QCTaskRow>['components'];
    rowClassName: (row: QCTaskRow) => string;
    onRow: NonNullable<TableProps<QCTaskRow>['onRow']>;
  };
}
